var YouLi = YouLi ? YouLi : {};
YouLi.CreditCardPaymentForm = YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {};
YouLi.CreditCardPaymentForm.StripePay = YouLi.CreditCardPaymentForm.StripePay ? YouLi.CreditCardPaymentForm.StripePay : {};

(function (YouLi) {
    (function (CreditCardPaymentForm) {
        (function (StripePay) {

            YouLi.CreditCardPaymentForm.StripeCustomerId = null;
            YouLi.CreditCardPaymentForm.IsAdaptivePricingEnabled = false;
            YouLi.CreditCardPaymentForm.PaymentGatewaySpecificMethod = null;

            // private variables
            let checkoutActions;
            let expressCheckoutElement;
            let hasCustomerEmailOnLoad = false;
            let adaptivePricingCurrency = null;

            YouLi.CreditCardPaymentForm.StripePay.InitialiseStripe = function () {
                if (YouLi.CreditCardPaymentForm.IsAllowCheckoutSession) {
                    return initializeCheckoutSession();
                } else {
                    return initializePaymentIntent();
                }
            };

            YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent = function (paymentId, doSetupCustomer = false, useBillingDetails = false) {
                if (YouLi.CreditCardPaymentForm.IsAllowCheckoutSession) {
                    return stripeRefreshCheckoutSession(paymentId, doSetupCustomer, useBillingDetails);
                } else {
                    return stripeRefreshPaymentIntent(paymentId, doSetupCustomer, useBillingDetails);
                }
            }

            YouLi.CreditCardPaymentForm.StripePay.CompleteStripePayment = function () {

                // Validate the form before anything else
                let $form = $('#GenericPaymentForm');
                $form.validateBootstrap();
                if (!$form.valid()) {
                    document.getElementById("GenericPaymentForm").scrollTo(0, 0);
                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                    if (hasBillingAddress()) {
                        YouLi.CreditCardPaymentForm.ShowErrorInModal("Please complete the billing address and email address below.");
                    } else {
                        YouLi.CreditCardPaymentForm.ShowErrorInModal("Please complete the email address below.");
                    }

                    return;
                }

                if (YouLi.CreditCardPaymentForm.StripeElements == undefined) {
                    YouLi.CreditCardPaymentForm.ShowErrorInModal("Payment form has not been loaded, please wait");
                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                    return;
                }

                if (YouLi.CreditCardPaymentForm.IsAllowCheckoutSession) {
                    confirmPaymentCheckoutSession();
                } else {
                    confirmPaymentPaymentIntent();
                }
            }

            function hasBillingAddress() {
                return $("#BillToFieldsIncluded") && $("#BillToFieldsIncluded").val() == "true";
            }

            // Payment Intent

            function initializePaymentIntent() {

                // no need to initialise for preview (shouldn't load up, anyway) or if the Stripe Elements has already been set up
                if ($("#PreviewMode").val() == "True" || YouLi.CreditCardPaymentForm.StripeElements != undefined)
                    return Promise.resolve();

                // initially disable the pay button until Stripe has loaded
                $("#p-creditcard").attr("disabled", true);

                $(document).off("change", "#ChargeAmount");
                $(document).on("change", "#ChargeAmount", function () {
                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                $(document).off("change", "#SaveCard");
                $(document).on("change", "#SaveCard", function () {

                    if ($("#AutoPayEnrolOption", "#GenericPaymentFormDialog").length > 0 && !YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate && YouLi.CreditCardPaymentForm.ShowAutoPay) {
                        $("#AutoPayEnrolOption", "#GenericPaymentFormDialog").toggleClass("disabled", !$(this).is(":checked"));
                        $("#EnrolInAutoPay", "#GenericPaymentFormDialog").attr("disabled", !$(this).is(":checked"));

                        if (!$(this).is(":checked"))  // clear autopay if it is no longer allowed
                            $("#EnrolInAutoPay", "#GenericPaymentFormDialog").prop("checked", false);
                    }

                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                $("#SaveCard.planner-save-card").off("change");
                $("#SaveCard.planner-save-card").on("change", function () {
                    $("#SaveCardPlannerDetails").toggleClass("hidden", !$(this).is(":checked"));
                });

                $('input[name="SaveCardDestination"]').off("change");
                $('input[name="SaveCardDestination"]').on("change", function () {
                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                $(document).on("change", "#GenericPaymentFormDialog #EnrolInAutoPay", function () {

                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                // initialise tooltip for Save Card manually (if needed)
                $('#SaveCardPlannerDetails [data-toggle="tooltip"]').tooltip({
                    trigger: "hover focus",
                    container: "body"
                });

                YouLi.CreditCardPaymentForm.StripeHandler = Stripe(YouLi.CreditCardPaymentForm.StripeKey, {
                    stripeAccount: YouLi.CreditCardPaymentForm.ConnectedPaymentGatewayUserId
                });

                let data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val()
                };

                return YouLi.Common.Post({
                    url: '/trip/createupdatestripepaymentintent',
                    params: data,
                    suppressLoading: true,
                    errorCallback: function (error) {
                        YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message || error);
                        $("#BillingAddressSection").hide();
                        $("#BillingInformationLabel").hide();
                        $("#p-creditcard").hide();
                    }
                }).then(data => {

                    if (!data.success) {
                        throw new Error(data.message);
                    }

                    const clientSecret = data.clientSecret;
                    YouLi.CreditCardPaymentForm.StripePaymentIntentId = data.paymentIntentId;

                    const appearance = {
                        theme: 'stripe',
                        variables: {
                            fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
                            fontSizeBase: '16px',
                            borderRadius: '0px',
                            colorPrimary: '#003049',
                            colorBackground: '#FFFFFF',
                            colorText: '#343F46',
                            colorDanger: '#F15641'
                        }
                    };

                    const fonts = [
                        {
                            cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans'
                        }
                    ];

                    YouLi.CreditCardPaymentForm.StripeElements = YouLi.CreditCardPaymentForm.StripeHandler.elements({
                        appearance,
                        fonts,
                        clientSecret
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement = YouLi.CreditCardPaymentForm.StripeElements.create("payment");

                    YouLi.CreditCardPaymentForm.StripePaymentElement.on('ready', function () {
                        $("#p-creditcard").attr("disabled", false);
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement.on('change', function (e) {
                        if (e.elementType == "payment") {
                            YouLi.CreditCardPaymentForm.IsFutureUsageAllowed = (e.value.type == "card" || e.value.type === "us_bank_account");
                            let $genericSurcharge = $('.generic-card-surcharge-container');

                            const pmType = e.value.type;
                            YouLi.CreditCardPaymentForm.SelectedPaymentMethodType = pmType;

                            // toggle the "Save card" option (and clear it if it as checked and no longer should be)
                            $("#SaveCardOption").toggleClass("hidden", !YouLi.CreditCardPaymentForm.IsFutureUsageAllowed);
                            if (!YouLi.CreditCardPaymentForm.IsFutureUsageAllowed)
                                $("#SaveCard").prop("checked", false);

                            if ($("#AutoPayEnrolOption", "#GenericPaymentFormDialog").length > 0 && !YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate && YouLi.CreditCardPaymentForm.ShowAutoPay) {
                                $("#AutoPayEnrolOption", "#GenericPaymentFormDialog").toggleClass("hidden", !YouLi.CreditCardPaymentForm.IsFutureUsageAllowed);

                                if (!YouLi.CreditCardPaymentForm.IsFutureUsageAllowed) // clear autopay if it is no longer allowed
                                    $("#EnrolInAutoPay", "#GenericPaymentFormDialog").prop("checked", false);
                            }

                            $genericSurcharge.addClass('hidden');

                            $genericSurcharge.find('.generic-card-surcharge')
                                .text(YouLi.PaymentChargeForm.GetSurchargePercent(e.value.type));

                            $genericSurcharge.find('.generic-card-surcharge-amount')
                                .text(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetSurchargeAmount(e.value.type)));

                            if (YouLi.PaymentChargeForm.Ach.HasSurcharge === true) {
                                const totalAmount = YouLi.PaymentChargeForm.GetStripeChargeAmount(e.value.type);

                                $('#GenericPaymentFormDialog')
                                    .find('.cost-line-item-amount-payment-total')
                                    .html(YouLi.PaymentChargeForm.GetFormattedCurrency(totalAmount));
                                $("#ChargeAmount").val(totalAmount);
                                $("input[Name=SurchargeAmount]").val(YouLi.PaymentChargeForm.GetSurchargeAmount(e.value.type))
                                $("input[Name=RefundProtectAmount]").val(YouLi.PaymentChargeForm.GetRefundProtectAmount(e.value.type));

                                $genericSurcharge.removeClass('hidden');
                                YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false)
                            }
                        }
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement.mount("#payment-element");

                }).catch((error) => {
                    YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message || error);
                    $("#BillingAddressSection").hide();
                    $("#BillingInformationLabel").hide();
                    $("#p-creditcard").hide();
                });
            }

            function stripeRefreshPaymentIntent(paymentId, doSetupCustomer = false, useBillingDetails = false) {
                if (!YouLi.CreditCardPaymentForm.StripePaymentIntentId)
                    return; // no PI created yet, anyway

                let data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    inviteeReferenceCode: YouLi.CreditCardPaymentForm.InviteeReferenceCode,
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val(),
                    existingPaymentIntentId: YouLi.CreditCardPaymentForm.StripePaymentIntentId,
                    paymentId: paymentId,
                    doSetupCustomer: doSetupCustomer,
                    email: $("#p-billto-email").val(),
                    firstname: $("#p-billto-first-name").val(),
                    lastname: $("#p-billto-last-name").val(),
                    isFutureUsageAllowed: YouLi.CreditCardPaymentForm.IsFutureUsageAllowed,
                    isRegisteredWithPayment: YouLi.CreditCardPaymentForm.IsRegisteredWithPayment,
                    isSaveCard: $("#SaveCard").is(":checked"),
                    isAutoPayEnrol: $("#EnrolInAutoPay", "#GenericPaymentFormDialog").is(":checked"),
                    saveCardDestination: $("input[name='SaveCardDestination']").length > 0 ? $("input[name='SaveCardDestination']:checked").val() : "account",
                    chargeReservationNumber: $("#ChargeReservationNumber").val()
                };

                if (hasBillingAddress() && useBillingDetails) {
                    data.showBillingAddressOnPayment = hasBillingAddress();
                    data.billToFirstName = $("#p-billto-first-name").val();
                    data.billToLastName = $("#p-billto-last-name").val();
                    data.billToEmail = $("#p-billto-email").val();
                    data.billToStreetLine1 = $("#p-billto-street-line1").val();
                    data.billToStreetLine2 = $("#p-billto-street-line2").val();
                    data.billToCity = $("#p-billto-city").val();
                    data.billToState = $("#p-billto-state").val();
                    data.billToCountry = $("#p-billto-country").val();
                    data.postCode = $("#p-postal-code").val();
                }

                return new Promise(function (resolve, reject) {
                    YouLi.Common.Post({
                        url: '/trip/createupdatestripepaymentintent',
                        params: data,
                        suppressLoading: true,
                        errorCallback: function (error) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message || error);
                            reject({
                                message: 'Error updating payment intent',
                                errorHandled: true
                            });
                        }
                    }).then(function (response) {
                        if (!response.success) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal(response.message);
                            reject({
                                message: 'Error updating payment intent',
                                errorHandled: true
                            });
                            return;
                        }

                        resolve(response);
                    });
                });
            }

            function confirmPaymentPaymentIntent() {
                let newPaymentId, couponPaymentId;

                YouLi.CreditCardPaymentForm.StripeElements.submit()
                    .then((submitResult) => {
                        if (submitResult.error) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal(submitResult.error.message);
                            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                            throw { message: submitResult.error.message, errorHandled: true };
                        }

                        return YouLi.CreditCardPaymentForm.CheckForOverpayment();
                    }).then(() => {

                    // 2. call the function to process the payment (which should itself create the payment but with an inprogress status)

                    return YouLi.CreditCardPaymentForm.ProcessStripePaymentFunction(YouLi.CreditCardPaymentForm.StripePaymentIntentId, "stripe");
                }).then((data) => {

                    newPaymentId = data.newPaymentId;
                    couponPaymentId = data.couponPaymentId;

                    if (data.redirectURL) {
                        YouLi.CreditCardPaymentForm.StripeRedirectURL = data.redirectURL;
                    } else {
                        // force redirect to the same page where the payment was made
                        YouLi.CreditCardPaymentForm.StripeRedirectURL = window.location.href;
                    }

                    // 3. Refresh Payment Intent to include the data we need on return

                    // First, ensure it's actually got a paymentId
                    if (!newPaymentId) {
                        var userMessage = "An error occurred with the payment charge - invalid payment Id";
                        var debugMessage = "Credit Card failure: passed a " + (newPaymentId == null ? "null" : "empty string") + " for paymentId on trip "
                            + $("#TripId").val() + " for invitee " + $("#InviteeId").val() + " is failing. Domain: " + window.location.host
                        var subject = "Exception occurring - internalPaymentId is being set to an invalid value in Stripe Payment Intent";

                        YouLi.Common.OpenSupportTicket(userMessage, debugMessage, subject);

                        throw new Error(userMessage);
                    }

                    return YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(newPaymentId, true, true);
                }).then((response) => {
                    // 4. Call the Stripe confirmPayment function to process there
                    const elements = YouLi.CreditCardPaymentForm.StripeElements;

                    YouLi.CreditCardPaymentForm.StripeHandler.confirmPayment({
                        elements,
                        confirmParams: {
                            return_url: YouLi.CreditCardPaymentForm.StripeRedirectURL
                        }
                    }).then((response) => {

                        // 4. handle any immediate errors that come up
                        // This point will only be reached if there is an immediate error when
                        // confirming the payment. Otherwise, they will be redirected to
                        // `return_url` (after any intermediate steps are completed)
                        if (response.error.type === "card_error" || response.error.type === "validation_error") {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal("Error processing payment: " + response.error.message);
                        } else {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal("An unexpected error occurred, review details below");
                        }

                        YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                        // 5. need to roll back the created "inprogress" payment (and any created coupon payment) if a payment was created!
                        // Return this promise rather than waiting for it here, the user can carry on
                        var paymentsToDelete = [];
                        if (newPaymentId)
                            paymentsToDelete.push(newPaymentId);
                        if (couponPaymentId)
                            paymentsToDelete.push(couponPaymentId);
                        return YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);
                    });
                }).catch((errorObject) => {
                    console.error('Error:', errorObject.message);

                    // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                    var paymentsToDelete = [];
                    if (newPaymentId)
                        paymentsToDelete.push(newPaymentId);
                    if (couponPaymentId)
                        paymentsToDelete.push(couponPaymentId);
                    YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                    if (!errorObject.errorHandled) {
                        YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                    }

                });
            }

            // Checkout session

            function initializeCheckoutSession() {
                // no need to initialise for preview (shouldn't load up, anyway) or if the Stripe Elements has already been set up
                if ($("#PreviewMode").val() == "True" || YouLi.CreditCardPaymentForm.StripeElements != undefined)
                    return Promise.resolve();

                $('#express-checkout-element').addClass('hidden');

                // initially disable the pay button until Stripe has loaded
                $("#p-creditcard").attr("disabled", true);

                $(document).off("change", "#ChargeAmount");
                $(document).on("change", "#ChargeAmount", function () {
                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                $(document).off("change", "#SaveCard");
                $(document).on("change", "#SaveCard", function () {

                    if ($("#AutoPayEnrolOption", "#GenericPaymentFormDialog").length > 0 && !YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate && YouLi.CreditCardPaymentForm.ShowAutoPay) {
                        $("#AutoPayEnrolOption", "#GenericPaymentFormDialog").toggleClass("disabled", !$(this).is(":checked"));
                        $("#EnrolInAutoPay", "#GenericPaymentFormDialog").attr("disabled", !$(this).is(":checked"));

                        if (!$(this).is(":checked"))  // clear autopay if it is no longer allowed
                            $("#EnrolInAutoPay", "#GenericPaymentFormDialog").prop("checked", false);
                    }

                    checkAutoPayOnAdaptivePricing();

                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                $("#SaveCard.planner-save-card").off("change");
                $("#SaveCard.planner-save-card").on("change", function () {
                    $("#SaveCardPlannerDetails").toggleClass("hidden", !$(this).is(":checked"));
                });

                $('input[name="SaveCardDestination"]').off("change");
                $('input[name="SaveCardDestination"]').on("change", function () {
                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                $("#p-billto-email").off('blur').on('blur', function () {
                    if (!$(this).prop('readonly') && !hasCustomerEmailOnLoad)
                        checkoutActions.updateEmail($(this).val());
                })

                $(document).on("change", "#GenericPaymentFormDialog #EnrolInAutoPay", function () {

                    YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false);
                });

                // initialise tooltip for Save Card manually (if needed)
                $('#SaveCardPlannerDetails [data-toggle="tooltip"]').tooltip({
                    trigger: "hover focus",
                    container: "body"
                });

                YouLi.CreditCardPaymentForm.StripeHandler = Stripe(YouLi.CreditCardPaymentForm.StripeKey, {
                    stripeAccount: YouLi.CreditCardPaymentForm.ConnectedPaymentGatewayUserId
                });

                let data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val(),
                    firstname: $("#p-billto-first-name").val(),
                    lastname: $("#p-billto-last-name").val(),
                    email: $("#p-billto-email").val(),
                    existingCustomerId: YouLi.CreditCardPaymentForm.StripeCustomerId,
                    isFutureUsageAllowed: YouLi.CreditCardPaymentForm.IsFutureUsageAllowed,
                    inviteeReferenceCode: YouLi.CreditCardPaymentForm.InviteeReferenceCode,
                    chargeReservationNumber: $("#ChargeReservationNumber").val(),
                    stripePaymentMethod: YouLi.CreditCardPaymentForm.PaymentGatewaySpecificMethod,
                };

                return YouLi.Common.Post({
                    url: '/trip/CreateUpdateStripeCheckoutSession',
                    params: data,
                    suppressLoading: true,
                    errorCallback: function (error) {
                        YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message || error);
                        $("#BillingAddressSection").hide();
                        $("#BillingInformationLabel").hide();
                        $("#p-creditcard").hide();
                    }
                }).then(data => {

                    if (!data.success) {
                        throw new Error(data.message);
                    }

                    const clientSecret = data.clientSecret;
                    YouLi.CreditCardPaymentForm.StripePaymentIntentId = data.paymentIntentId;
                    YouLi.CreditCardPaymentForm.StripeCustomerId = null;

                    const appearance = {
                        theme: 'stripe',
                        variables: {
                            fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
                            fontSizeBase: '16px',
                            borderRadius: '0px',
                            colorPrimary: '#003049',
                            colorBackground: '#FFFFFF',
                            colorText: '#343F46',
                            colorDanger: '#F15641'
                        }
                    };

                    const fonts = [
                        {
                            cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans'
                        }
                    ];

                    YouLi.CreditCardPaymentForm.StripeElements = YouLi.CreditCardPaymentForm.StripeHandler.initCheckout({
                        clientSecret: clientSecret,
                        elementsOptions: {appearance, fonts},
                        adaptivePricing: {
                            allowed: YouLi.CreditCardPaymentForm.IsAdaptivePricingEnabled
                        }
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement = YouLi.CreditCardPaymentForm.StripeElements.createPaymentElement({
                        wallets: {
                            applePay: 'never',
                            googlePay: 'never'
                        }
                    });

                    YouLi.CreditCardPaymentForm.StripeElements.loadActions().then(function (loadActionsResult) {
                        if (loadActionsResult.type === 'success') {
                            checkoutActions = loadActionsResult.actions;
                            const session = loadActionsResult.actions.getSession();

                            if (session) {
                                hasCustomerEmailOnLoad = session.email !== null && session.email !== "";
                            }
                        }

                        initialiseExpressCheckoutElement();
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement.on('ready', function () {
                        $("#p-creditcard").attr("disabled", false);
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement.on('change', function (e) {
                        if (e.elementType == "payment") {
                            YouLi.CreditCardPaymentForm.IsFutureUsageAllowed = YouLi.CreditCardPaymentForm.IsAllowSaveCard && (e.value.type === 'card' || e.value.type === 'us_bank_account');
                            let $genericSurcharge = $('.generic-card-surcharge-container');

                            YouLi.CreditCardPaymentForm.SelectedPaymentMethodType = e.value.type;

                            // toggle the "Save card" option (and clear it if it as checked and no longer should be)
                            $("#SaveCardOption").toggleClass("hidden", !YouLi.CreditCardPaymentForm.IsFutureUsageAllowed);
                            if (!YouLi.CreditCardPaymentForm.IsFutureUsageAllowed)
                                $("#SaveCard").prop("checked", false).trigger("change");

                            if ($("#AutoPayEnrolOption", "#GenericPaymentFormDialog").length > 0 && !YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate && YouLi.CreditCardPaymentForm.ShowAutoPay) {
                                $("#AutoPayEnrolOption", "#GenericPaymentFormDialog").toggleClass("hidden", !YouLi.CreditCardPaymentForm.IsFutureUsageAllowed);

                                if (!YouLi.CreditCardPaymentForm.IsFutureUsageAllowed) // clear autopay if it is no longer allowed
                                    $("#EnrolInAutoPay", "#GenericPaymentFormDialog").prop("checked", false);
                            }

                            $genericSurcharge.addClass('hidden');

                            $genericSurcharge.find('.generic-card-surcharge')
                                .text(YouLi.PaymentChargeForm.GetSurchargePercent(e.value.type));

                            $genericSurcharge.find('.generic-card-surcharge-amount')
                                .text(YouLi.PaymentChargeForm.GetFormattedCurrency(YouLi.PaymentChargeForm.GetSurchargeAmount(e.value.type)));

                            if (YouLi.PaymentChargeForm.Ach.HasSurcharge === true) {
                                const totalAmount = YouLi.PaymentChargeForm.GetStripeChargeAmount(e.value.type);

                                $('#GenericPaymentFormDialog')
                                    .find('.cost-line-item-amount-payment-total')
                                    .html(YouLi.PaymentChargeForm.GetFormattedCurrency(totalAmount));
                                $("#ChargeAmount").val(totalAmount);
                                $("input[Name=SurchargeAmount]").val(YouLi.PaymentChargeForm.GetSurchargeAmount(e.value.type))
                                $("input[Name=RefundProtectAmount]").val(YouLi.PaymentChargeForm.GetRefundProtectAmount(e.value.type));

                                $genericSurcharge.removeClass('hidden');
                                YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(/*paymentId*/null, /*doSetupCustomer*/false, /*useBillingDetails*/false)
                            }
                        }
                    });

                    YouLi.CreditCardPaymentForm.StripePaymentElement.mount("#payment-element");

                    if (YouLi.CreditCardPaymentForm.IsAdaptivePricingEnabled) {
                        const currencySelectorElement = YouLi.CreditCardPaymentForm.StripeElements.createCurrencySelectorElement();
                        currencySelectorElement.mount("#currency-selector-element");

                        YouLi.CreditCardPaymentForm.StripeElements.on('change', (session) => {
                            document.querySelector("#p-creditcard").textContent = `Pay ${session.total.total.amount}`;
                        });

                        currencySelectorElement.on('change', (session) => {
                            adaptivePricingCurrency = session.value.currency.toUpperCase();
                            checkAutoPayOnAdaptivePricing();
                        });
                    }

                }).catch((error) => {
                    YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message || error);
                    $("#BillingAddressSection").hide();
                    $("#BillingInformationLabel").hide();
                    $("#p-creditcard").hide();
                });
            }

            function stripeRefreshCheckoutSession(paymentId, doSetupCustomer = false, useBillingDetails = false) {
                if (!YouLi.CreditCardPaymentForm.StripePaymentIntentId)
                    return; // no PI created yet, anyway

                let data = {
                    tripId: $("#TripId").val(),
                    inviteeId: $("#InviteeId").val(),
                    chargeAmount: $("#ChargeAmount").val(),
                    chargeLabel: $("#ChargeLabel").val(),
                    existingPaymentIntentId: YouLi.CreditCardPaymentForm.StripePaymentIntentId,
                    paymentId: paymentId,
                    email: $("#p-billto-email").val(),
                    firstname: $("#p-billto-first-name").val(),
                    lastname: $("#p-billto-last-name").val(),
                    isFutureUsageAllowed: YouLi.CreditCardPaymentForm.IsFutureUsageAllowed,
                    isRegisteredWithPayment: YouLi.CreditCardPaymentForm.IsRegisteredWithPayment,
                    isSaveCard: $("#SaveCard").is(":checked"),
                    isAutoPayEnrol: $("#EnrolInAutoPay", "#GenericPaymentFormDialog").is(":checked"),
                    saveCardDestination: $("input[name='SaveCardDestination']").length > 0 ? $("input[name='SaveCardDestination']:checked").val() : "account",
                    chargeReservationNumber: $("#ChargeReservationNumber").val()
                };

                if (hasBillingAddress() && useBillingDetails) {
                    checkoutActions.updateShippingAddress({
                        name: $("#p-billto-first-name").val() + " " + $("#p-billto-last-name").val(),
                        address: {
                            line1: $("#p-billto-street-line1").val(),
                            line2: $("#p-billto-street-line2").val(),
                            city: $("#p-billto-city").val(),
                            state: $("#p-billto-state").val(),
                            postal_code: $("#p-postal-code").val(),
                            country: $("#p-billto-country").val()
                        }
                    });
                }

                $('#p-billto-email').trigger('blur');

                return new Promise(function (resolve, reject) {
                    YouLi.Common.Post({
                        url: '/trip/CreateUpdateStripeCheckoutSession',
                        params: data,
                        suppressLoading: true,
                        errorCallback: function (error) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message || error);
                            reject({
                                message: 'Error updating payment intent',
                                errorHandled: true
                            });
                        }
                    }).then(function (response) {
                        if (!response.success) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal(response.message);
                            reject({
                                message: 'Error updating payment intent',
                                errorHandled: true
                            });
                            return;
                        }

                        resolve(response);
                    });
                });
            }

            function checkAutoPayOnAdaptivePricing() {
                if ($("#AutoPayEnrolOption").length > 0
                    && !YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate
                    && YouLi.CreditCardPaymentForm.ShowAutoPay
                    && YouLi.CreditCardPaymentForm.IsAdaptivePricingEnabled) {

                    const isAllowAutoPay = YouLi.CreditCardPaymentForm.Currency.Code === adaptivePricingCurrency
                    const toolTip = isAllowAutoPay ? "" : `Cannot pay in local currency and enrol in Autopay. Select [${YouLi.CreditCardPaymentForm.Currency.Code}] to enroll in AutoPay.`;

                    // this already assumes that we are allow to do auto pay here.
                    $('#AutoPayEnrolOption')
                        .attr('data-content', toolTip)
                        .toggleClass('disabled', !isAllowAutoPay);
                    $('#EnrolInAutoPay')
                        .attr('disabled', !isAllowAutoPay)
                        .prop('checked', false);

                    // enforce due to the toggle above
                    YouLi.Common.UI.Init();
                }
            }

            function confirmPaymentCheckoutSession(expressCheckoutConfirmEvent) {

                let newPaymentId, couponPaymentId;

                Promise.resolve()
                    .then(() => {

                        // Validate the form before anything else
                        let $form = $('#GenericPaymentForm');
                        $form.validateBootstrap();
                        if (!$form.valid()) {
                            document.getElementById("GenericPaymentForm").scrollTo(0, 0);
                            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                            if (hasBillingAddress()) {
                                throw { message: 'Please complete the billing address and email address below.', errorHandled: true };
                            } else {
                                throw { message: 'Please complete the email address below.', errorHandled: true };
                            }
                        }

                        if (YouLi.CreditCardPaymentForm.StripeElements == undefined) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal("Payment form has not been loaded, please wait");

                            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                            throw { message: 'Payment form has not been loaded, please wait', errorHandled: true };
                        }

                        // enforce for wallet payment so that we don't encounter issues
                        if (expressCheckoutConfirmEvent) {
                            $("#SaveCard").prop("checked", false);
                            $("#EnrolInAutoPay", "#GenericPaymentFormDialog").prop("checked", false);
                        }

                        return YouLi.CreditCardPaymentForm.CheckForOverpayment();
                    }).then(() => {

                    // 2. call the function to process the payment (which should itself create the payment but with an inprogress status)

                    return YouLi.CreditCardPaymentForm.ProcessStripePaymentFunction(YouLi.CreditCardPaymentForm.StripePaymentIntentId, "stripe");
                    }).then((data) => {

                        newPaymentId = data.newPaymentId;
                        couponPaymentId = data.couponPaymentId;

                        if (data.redirectURL) {
                            YouLi.CreditCardPaymentForm.StripeRedirectURL = data.redirectURL;
                        } else {
                            // force redirect to the same page where the payment was made
                            YouLi.CreditCardPaymentForm.StripeRedirectURL = window.location.href;
                        }

                        // 3. Refresh Payment Intent to include the data we need on return

                        // First, ensure it's actually got a paymentId
                        if (!newPaymentId) {
                            var userMessage = "An error occurred with the payment charge - invalid payment Id";
                            var debugMessage = "Credit Card failure: passed a " + (newPaymentId == null ? "null" : "empty string") + " for paymentId on trip "
                                + $("#TripId").val() + " for invitee " + $("#InviteeId").val() + " is failing. Domain: " + window.location.host
                            var subject = "Exception occurring - internalPaymentId is being set to an invalid value in Stripe Payment Intent";

                            YouLi.Common.OpenSupportTicket(userMessage, debugMessage, subject);

                            throw new Error(userMessage);
                        }

                        return YouLi.CreditCardPaymentForm.StripePay.StripeRefreshPaymentIntent(newPaymentId, true, true);
                    }).then((response) => {
                        // Make assumptions here that any # would be converted to a new param ?pageFlow
                        // Pages would need to manually handle this to a redirection load to be removed and properly redirected
                        const url = new URL(YouLi.CreditCardPaymentForm.StripeRedirectURL);

                        if (url.hash && url.hash.length > 1) {
                            const hashValue = url.hash.slice(1);

                            url.searchParams.set("pageFlow", hashValue);
                            url.hash = "";
                        }

                        YouLi.CreditCardPaymentForm.StripeRedirectURL = url.toString();

                        let confirmOptions = {
                            returnUrl: YouLi.CreditCardPaymentForm.StripeRedirectURL
                        };

                        if (expressCheckoutConfirmEvent) {
                            confirmOptions.expressCheckoutConfirmEvent = expressCheckoutConfirmEvent;
                        }

                        checkoutActions.confirm(confirmOptions).then((response) => {

                            console.log("Error confirming payment:", response);
                            // 4. handle any immediate errors that come up
                            // This point will only be reached if there is an immediate error when
                            // confirming the payment. Otherwise, they will be redirected to
                            // `return_url` (after any intermediate steps are completed)
                            if (response.type === "error") {
                                YouLi.CreditCardPaymentForm.ShowErrorInModal("Error processing payment: " + response.error.message);
                            }

                            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                            // 5. need to roll back the created "inprogress" payment (and any created coupon payment) if a payment was created!
                            // Return this promise rather than waiting for it here, the user can carry on
                            let paymentsToDelete = [];
                            if (newPaymentId)
                                paymentsToDelete.push(newPaymentId);
                            if (couponPaymentId)
                                paymentsToDelete.push(couponPaymentId);
                            return YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);
                        });
                    }).catch((errorObject) => {
                        console.error('Error:', errorObject.message);

                        // roll back the payment (and any created coupon payment) that was created locally if a payment was created
                        var paymentsToDelete = [];
                        if (newPaymentId)
                            paymentsToDelete.push(newPaymentId);
                        if (couponPaymentId)
                            paymentsToDelete.push(couponPaymentId);
                        YouLi.CreditCardPaymentForm.CancelInProgressPayment(paymentsToDelete);

                        YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                        if (!errorObject.errorHandled) {
                            YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(errorObject.message, moment());
                        }

                        // this triggers a payment failure for wallet so that the page doesn't bug out and the user can try again
                        if (expressCheckoutConfirmEvent) {
                            YouLi.CreditCardPaymentForm.ShowErrorInModal(errorObject.message);
                            expressCheckoutConfirmEvent.paymentFailed({
                                reason: 'fail'
                            });
                        }
                    });
            }

            function initialiseExpressCheckoutElement() {
                if (expressCheckoutElement) {
                    expressCheckoutElement.destroy();
                    expressCheckoutElement = null;
                }

                if (YouLi.CreditCardPaymentForm.StripeElements == undefined) {
                    return;
                }

                if ($('#express-checkout-element').length === 0) {
                    return;
                }

                expressCheckoutElement = YouLi.CreditCardPaymentForm.StripeElements.createExpressCheckoutElement({
                    buttonType: {
                        applePay: 'buy',
                        googlePay: 'buy'
                    },
                    layout: { maxColumns: 1 },
                    paymentMethods : {
                        link: 'never',
                        paypal: 'never',
                        klarna: 'never'
                    }
                });

                expressCheckoutElement.on('confirm', function (event) {
                    confirmPaymentCheckoutSession(event);
                });

                expressCheckoutElement.on('ready', function () {
                    $('#express-checkout-element').removeClass('hidden');
                });

                expressCheckoutElement.mount('#express-checkout-element');
            }

            $(function () {

                if (YouLi.CreditCardPaymentForm.IsAllowCheckoutSession) {
                    // Default to True for checkout session only
                    if (YouLi.CreditCardPaymentForm.IsAllowSaveCard) {
                        YouLi.CreditCardPaymentForm.IsFutureUsageAllowed = true;
                    } else {
                        YouLi.CreditCardPaymentForm.IsFutureUsageAllowed = false;
                    }
                    YouLi.CreditCardPaymentForm.StripeIntegrationType = 'CheckoutSession';
                    adaptivePricingCurrency = YouLi.CreditCardPaymentForm.Currency.Code;
                } else {
                    YouLi.CreditCardPaymentForm.StripeIntegrationType = 'PaymentIntent';
                }
            });
        }(YouLi.CreditCardPaymentForm.StripePay ? YouLi.CreditCardPaymentForm.StripePay : {}));
    }(YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {}));
}(YouLi ? YouLi : {}));